import { FunctionComponent } from 'react';
import * as React from 'react';
import classNames from 'classnames';

import classes from './container.module.scss';

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const Container: FunctionComponent<ContainerProps> = ({
  className,
  ...props
}) => <div className={classNames(classes.container, className)} {...props} />;
